import PropTypes from 'prop-types';
import { Alert, Flex, Typography } from 'antd';
import { getFailedArticleImages } from '../utils/article-arcs';

const getImageTitle = (image, index) => image?.alt || image?.path || `配图 ${index + 1}`;

const getAttemptText = (attempts) =>
  Number.isFinite(Number(attempts)) && Number(attempts) > 0 ? `已尝试 ${attempts} 次` : null;

const renderFailedImage = (image, index) => {
  const attemptText = getAttemptText(image?.attempts);
  return (
    <Flex key={`${image?.path || index}`} vertical>
      <Typography.Text strong>{getImageTitle(image, index)}</Typography.Text>
      <Typography.Text type="secondary">
        {image?.errorMessage || '图片生成失败，请稍后重试'}
      </Typography.Text>
      {attemptText ? <Typography.Text type="secondary">{attemptText}</Typography.Text> : null}
    </Flex>
  );
};

const ArticleImageFailureSummary = ({ images }) => {
  const failedImages = getFailedArticleImages(images);
  if (failedImages.length === 0) {
    return null;
  }
  return (
    <Alert
      type="warning"
      showIcon
      title={`配图失败 ${failedImages.length} 张`}
      description={
        <Flex vertical gap="small">
          {failedImages.map(renderFailedImage)}
        </Flex>
      }
    />
  );
};

ArticleImageFailureSummary.propTypes = {
  images: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.string]),
};

ArticleImageFailureSummary.defaultProps = {
  images: [],
};

export default ArticleImageFailureSummary;
